export default __webpack_public_path__ + "static/img/wp_contact_3.b1a3602.jpg";